// // src/pages/ServitorRechargeHistory.jsx
// import React, { useEffect, useState } from 'react';
// import { useOutletContext } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';

// const ServitorRechargeHistory = () => {
//   const { t } = useTranslation('servitor');
//   const { servitor } = useOutletContext(); // from ServitorSiteLayoutWrapper
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!servitor?.Id) return;
//     fetch(`http://localhost:4001/servitors/${servitor.Id}/recharges`, {
//       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//     })
//       .then(res => {
//         if (!res.ok) throw new Error('Failed to fetch');
//         return res.json();
//       })
//       .then(data => {
//         setHistory(data);
//       })
//       .catch(err => {
//         console.error(err);
//         setError(t('rechargeHistory.fetchError'));
//       })
//       .finally(() => setLoading(false));
//   }, [servitor, t]);

//   if (loading) return <p>{t('common.loading')}</p>;
//   if (error)   return <p className="text-danger">{error}</p>;
//   if (history.length === 0) return <p>{t('rechargeHistory.noRecords')}</p>;

//   return (
//     <div className="servitorsite-orders-section">
//       <h3>{t('rechargeHistory.heading')}</h3>
//       <div className="completeorders-table-wrapper">
//         <table className="completeorders-table">
//           <thead>
//             <tr>
//               <th>{t('rechargeHistory.amount')}</th>
//               <th>{t('rechargeHistory.method')}</th>
//               <th>{t('rechargeHistory.date')}</th>
//             </tr>
//           </thead>
//           <tbody>
//             {history.map((r, i) => (
//               <tr key={i}>
//                 <td className="completeorders-td">
//                   {r.amount.toLocaleString()} {r.currency}
//                 </td>
//                 <td className="completeorders-td">
//                   {t(`paymentMethods.${r.paymentMethod}`) || r.paymentMethod}
//                 </td>
//                 <td className="completeorders-td">
//                   {new Date(r.created_at).toLocaleString()}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ServitorRechargeHistory;

import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ServitorRechargeHistory.css";
import { URL } from "../../config";
import Loader from "../../Components/LoaderSpin/Loader";

const ServitorRechargeHistory = () => {
  const { t } = useTranslation("servitor");
  const { servitor } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1", 10);
  const { pathname, search } = location;
  const navigateRef = React.useRef(navigate);

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [recharges, setRecharges] = useState([]);
  const [loading, setLoading] = useState(true);

  const rechargesPerPage = 10;

  useEffect(() => {
    if (servitor && servitor.Id) {
      fetch(`${URL}/recharge/history/${servitor.Id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const rechargesArray = Array.isArray(data) ? data : [];
          setRecharges(rechargesArray);
          setLoading(false);
        })
        .catch(() => {
          setRecharges([]);
          setLoading(false);
        });
    }
  }, [servitor]);

  useEffect(() => {
    const params = new URLSearchParams(search);
    params.set("page", currentPage);
    navigateRef.current(
      { pathname, search: params.toString() },
      { replace: true }
    );
  }, [currentPage, pathname, search]);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.toLocaleString("default", { month: "long" });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const indexOfLastRecharge = currentPage * rechargesPerPage;
  const indexOfFirstRecharge = indexOfLastRecharge - rechargesPerPage;
  const currentRecharges = recharges.slice(
    indexOfFirstRecharge,
    indexOfLastRecharge
  );
  const totalPages = Math.ceil(recharges.length / rechargesPerPage);
  const totalRecharges = recharges.length;
  const startRecharge = indexOfFirstRecharge + 1;
  const endRecharge = Math.min(indexOfLastRecharge, totalRecharges);


  const getDisplayTranId = (recharge) => {
    const userTrx = recharge?.senderTrxId;
    if (userTrx && String(userTrx).trim().length > 0) {
      return userTrx;
    }
    return recharge.tranId;
  };


  // if (loading)
  //   return <p className="rechargehistory-loading">{t("common.loading")}</p>;


  return (
    <div className="rechargehistory-container">
      <Loader show={loading} />
      <div className="rechargehistory-header">
        <h1 className="rechargehistory-title">
          {t("rechargeHistory.heading")}
        </h1>
      </div>

      {recharges.length === 0 ? (
        <p className="rechargehistory-empty">
          {t("rechargeHistory.noRecharges")}
        </p>
      ) : (
        <>
          <div className="rechargehistory-content">
            <div className="rechargehistory-desktop">
              <div className="rechargehistory-table-wrapper">
                <table className="rechargehistory-table">
                  <thead>
                    <tr>
                      <th className="rechargehistory-th">
                        {t("rechargeHistory.transactionId")}
                      </th>
                      <th className="rechargehistory-th">
                        {t("rechargeHistory.amount")}
                      </th>
                      <th className="rechargehistory-th">
                        {t("rechargeHistory.paymentMethod")}
                      </th>
                      <th className="rechargehistory-th">
                        {t("rechargeHistory.date")}
                      </th>
                      <th className="rechargehistory-th">
                        {t("rechargeHistory.status")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecharges.map((recharge, index) => (
                      <tr key={index} className="rechargehistory-row">
                        <td className="rechargehistory-td">
                          {/* {recharge.tranId} */}
                          {getDisplayTranId(recharge)}
                        </td>
                        <td className="rechargehistory-td rechargehistory-amount">
                          {recharge.amount} BDT
                        </td>
                        <td className="rechargehistory-td">
                          {recharge.paymentMethod.charAt(0).toUpperCase() +
                            recharge.paymentMethod.slice(1)}
                        </td>
                        <td className="rechargehistory-td">
                          {formatDate(recharge.created_at)}
                        </td>
                        <td className="rechargehistory-td">
                          <span
                            className={`rechargehistory-status rechargehistory-status-${recharge.status.toLowerCase()}`}
                          >
                            {recharge.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* <div className="rechargehistory-mobile">
              {currentRecharges.map((recharge, index) => (
                <div key={index} className="rechargehistory-card">
                  <div className="rechargehistory-card-header">
                    <div>
                      <h3 className="rechargehistory-card-title">{recharge.tranId}</h3>
                      <p className="rechargehistory-card-method">
                        {recharge.paymentMethod.charAt(0).toUpperCase() +
                          recharge.paymentMethod.slice(1)}
                      </p>
                    </div>
                    <div className="rechargehistory-card-right">
                      <p className="rechargehistory-card-amount">
                        {recharge.amount} BDT
                      </p>
                      <span className={`rechargehistory-status rechargehistory-status-${recharge.status.toLowerCase()}`}>
                        {recharge.status}
                      </span>
                    </div>
                  </div>
                  <div className="rechargehistory-card-body">
                    <div className="rechargehistory-card-item">
                      <span className="rechargehistory-card-label">
                        {t("rechargeHistory.date")}
                      </span>
                      <span className="rechargehistory-card-value">
                        {formatDate(recharge.created_at)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}

            <div className="rechargehistory-mobile">
              {currentRecharges.map((recharge, index) => (
                <div key={index} className="rechargehistory-card">
                  <div className="rechargehistory-card-row">
                    <div className="rechargehistory-card-field">
                      <span className="rechargehistory-card-label">
                        {t("rechargeHistory.transactionId")}:
                      </span>
                      <span className="rechargehistory-card-value">
                        {/* {recharge.tranId} */}
                        {getDisplayTranId(recharge)}
                      </span>
                    </div>
                    <div className="rechargehistory-card-field-right">
                      <span className="rechargehistory-card-label">
                        {t("rechargeHistory.amount")}:
                      </span>
                      <span className="rechargehistory-card-amount">
                        {recharge.amount} BDT
                      </span>
                    </div>
                  </div>
                  <div className="rechargehistory-card-row">
                    <div className="rechargehistory-card-field">
                      <span className="rechargehistory-card-label">
                        {t("rechargeHistory.paymentMethod")}:
                      </span>
                      <span className="rechargehistory-card-value">
                        {recharge.paymentMethod.charAt(0).toUpperCase() +
                          recharge.paymentMethod.slice(1)}
                      </span>
                    </div>
                    <div className="rechargehistory-card-field-right">
                      <span className="rechargehistory-card-label">
                        {t("rechargeHistory.date")}:
                      </span>
                      <span className="rechargehistory-card-value">
                        {formatDate(recharge.created_at)}
                      </span>
                    </div>
                  </div>
                  <div className="rechargehistory-card-status">
                    <span className="rechargehistory-card-label">
                      {t("rechargeHistory.status")}:
                    </span>
                    <span
                      className={`rechargehistory-status rechargehistory-status-${recharge.status.toLowerCase()}`}
                    >
                      {recharge.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rechargehistory-summary">
            {t("rechargeHistory.paginationSummary", {
              startRecharge,
              endRecharge,
              totalRecharges,
            })}
          </div>

          <div className="rechargehistory-pagination">
            <Pagination>
              <Pagination.First
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {t("rechargeHistory.previousPage")}
              </Pagination.Prev>
              <Pagination.Next
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {t("rechargeHistory.nextPage")}
              </Pagination.Next>
              <Pagination.Last
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </>
      )}
    </div>
  );
};

export default ServitorRechargeHistory;
